import m from "./../../../dist/es2015/themes/Seaborn.js";
export const am5themes_Seaborn = m;